import { Box } from '@mui/material';

import { Typography } from '@occc-app/design-system';
import { formatMoneyAmount } from '@occc-app/lib/currency';

type StoredValueBalanceProps = {
  balance: number;
};

export const StoredValueBalance = ({ balance }: StoredValueBalanceProps) => {
  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Typography variant='h4' component='strong'>
        {formatMoneyAmount(balance, { fromCents: true })}
      </Typography>
      <Typography color='textSecondary'>Stored Value</Typography>
    </Box>
  );
};
